import parse     from "html-react-parser";
import useStyles from "_styles/atoms/htmlParser";

/*
	For more use case refer to package:

	https://www.npmjs.com/package/html-react-parser
*/

const component = props => {
	const {
		textString,
		color = "primary"
	} = props;

	const { classes } = useStyles ( { color } );

	return (
		<div className = { classes.typography }>
			{ parse ( textString ) }
		</div>
	);
};

export default component;
